import { useCallback, useState } from "react";
import { AxiosError, AxiosResponse } from "axios";
import { handleBackendError, openNotification } from "../../../utils/helpers";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import InboxRepository from "../../../repositories/inbox-repository";
import { IResource } from "../../../utils/interfaces/resource.interface";
import { Inbox } from "../../../models/inbox";
import EmailTrackerRepository from "../../../repositories/email-tracker-repository";

export const useFormInbox = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [readLoading, setReadLoading] = useState<boolean>(false);
  const [updateLoading, setUpdateLoading] = useState<boolean>(false);
  const [deleteLoading, setDeleteLoading] = useState<boolean>(false);

  const onDelete = useCallback(
    async (id: number | string) => {
      setDeleteLoading(true);

      return new Promise((resolve, reject) => {
        InboxRepository.delete(id)
          .then((response: AxiosResponse) => {
            resolve(response);
          })
          .catch((e: AxiosError) => {
            handleBackendError(e, t("notification.error.default"));
            reject(e);
          })
          .finally(() => {
            setDeleteLoading(false);
          });
      });
    },
    [t]
  );

  const onRead = useCallback(
    async (id: string) => {
      setReadLoading(true);

      await InboxRepository.read(id)
        .catch((e: AxiosError) => {
          handleBackendError(e, t("notification.error.default"));
        })
        .finally(() => {
          setReadLoading(false);
        });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [t, navigate]
  );

  const handleStatusUpdate = useCallback(
    async (id: string, status: string) => {
      setUpdateLoading(true);

      await InboxRepository.update(id, { status })
        .then((response: AxiosResponse<IResource<Inbox>>) => {
          navigate(`/inbox/${id}`);
          openNotification(
            "success",
            t(`notification.success.updateItem`, {
              item: t("common.text.inbox"),
            })
          );
        })
        .catch((e: AxiosError) => {
          handleBackendError(e, t("notification.error.default"));
        })
        .finally(() => {
          setUpdateLoading(false);
        });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [t, navigate]
  );
  return {
    onRead,
    readLoading,
    updateLoading,
    handleStatusUpdate,
    onDelete,
    deleteLoading,
  };
};
